import { siteDerived } from '@/constants/siteDerived'
import EnvironmentHelper from '@/services/helpers/EnvironmentHelper'

export const TYPES = {
  EDIT_PRODUCT: 'edit-product',
  EDIT_CATEGORY: 'edit-category',
  EDIT_COLLECTION_PAGE: 'edit-collection-page',
  EDIT_CMS: 'edit-cms',
  EDIT_MANUFACTURER: 'edit-manufacturer',
  EDIT_REVIEW: 'edit-review',
  VIEW_CUSTOMER: 'view-customer',
  TRANSLATE_MODE: 'translate-mode',
  RELATED_PRODUCTS: 'related-products',
  HIGHLIGHT_CMS_ITEMS: 'highlight-cms-items',
  EDIT_CMS_BLOCK: 'edit-cms-block',
  TOGGLE_SOLR_DATA: 'toggle-solr-data',
  TOGGLE_DATALAYER_LOGGING: 'toggle-datalayer-logging',
  TOGGLE_ELBWALKER_LOGGING: 'toggle-elbwalker-logging',
  SET_CUSTOMER_ID: 'set-customer-id',
  SHOW_ELBWALKER_USER_DATA: 'show-elbwalker-user-data',
  PRODUCT_FILTER_OVERRIDES: 'product-filter-overrides'
}

// Gatekeeper feature that sends EDIT_PRODUCT to the VOS editor instead of the
// legacy one, so it can be switched on for single admins (customer restraint)
// before every admin moves over (VIP-12578).
export const VOS_PRODUCT_EDITOR_FEATURE = 'vos_product_editor'

const _buildUrls = (site) => {
  // VOS (product and collection page editor) is a separate app, hosted once per
  // environment: vos.vicampo.de, vos.vicampo-test.de on staging, vos.vicampo.test
  // locally - the .at/.ch shops link to the same host.
  const VOS_ROOT = EnvironmentHelper.detectVosRoot(site.domain)

  return {
    EDIT_PRODUCT:
      site.pageRoot + 'admin/catalog/admin_products/edit/scope_id/{0}/id/{1}', // 0: site_id 1: product_id
    EDIT_PRODUCT_IN_CAMPAIGN:
      site.pageRoot +
      'admin/catalog/admin_products/edit/scope_id/{0}/id/{1}/campaign_id/{2}', // 0: site_id 1: product_id 2: campaign_id
    EDIT_PRODUCT_VOS: VOS_ROOT + 'backend/products/{1}?siteId={0}', // 0: site_id 1: product_id
    EDIT_PRODUCT_VOS_IN_CAMPAIGN:
      VOS_ROOT + 'backend/products/{1}?siteId={0}&campaignId={2}', // 0: site_id 1: product_id 2: campaign_id — without a campaign VOS opens the site's default campaign
    EDIT_CATEGORY: site.pageRoot + 'admin/catalog/admin_categories/edit/id/{0}', // 0: category_id
    EDIT_COLLECTION_PAGE: VOS_ROOT + 'backend/collection-pages/site/{0}', // 0: collection_page_site_id — VOS resolves the owning campaign/brand/tab from it
    EDIT_CMS: site.pageRoot + 'admin/cms/admin_pages/edit/id/{0}', // 0: cms_id
    EDIT_MANUFACTURER:
      site.pageRoot +
      'admin/catalog/admin_manufacturers/edit/scope_id/{0}/id/{1}', // 0: site_id 1:manufacturer_id
    VIEW_CUSTOMER:
      site.pageRoot + 'admin/customer/admin_customers/view/hashid/{0}', // 0: hash_id
    EDIT_REVIEW: site.pageRoot + 'admin/review/admin_reviews/edit/hashid/{0}', // 0: hash_id
    CROSS_SELLS: site.pageRoot + 'catalog/cross-sells/{0}',
    EDIT_CMS_BLOCK: site.pageRoot + 'admin/cms/admin_blocks/edit/id/{0}'
  }
}

/** @type {ReturnType<typeof _buildUrls>} */
export const URLS = siteDerived(_buildUrls)
